<section class="main">
    <h3>Add new Village</h3>


    <label>Select Project</label>
    <div class="dropdown mb-0 ">
        <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown"
            aria-expanded="false">
            {{ProjectName}}
            <img src="assets/images/mangeunit/arrow.png">
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
            <li *ngFor="let item of project_arr">
                <a class="dropdown-item" (click)="getProjectData(item)">
                    {{item.name}}
                </a>
            </li>
        </ul>
    </div>
    <span *ngIf="statusProject" class="erorrMasge">Project is required</span>  

    <form (ngSubmit)="f1.form.valid && onSubmit(f1)" #f1="ngForm" novalidate>
        <div class="row mt-3">
            <div class="col">
                <div class="form-group">
                    <label>Village name</label>
                    <input required name="name"  [(ngModel)]="villageName"
                        placeholder="EX. Home"  #nameVillage="ngModel" type="text" class="form-control">
                   
                    <div *ngIf="nameVillage.errors && (nameVillage.touched || f1.submitted)">
                        <div class="erorrMasge" *ngIf="nameVillage.errors?.['required']">
                            <span class="erorrMasge">Village name is required</span>                                              
                        </div>                      
                 </div> 
                </div>
            </div>
        </div>

        <div class="addUnits d-flex justify-content-end mt-5 mb-2">
            <div>
                <button mat-dialog-close class="btn me-2">Cancel</button>
                <button class="btn addUnit">Add Village</button>
            </div>
        </div>
    </form>
</section>